import React from "react";
import AdminPanel from "./AdminPanel";
import "./OwnerDashboard.css";

export default function OwnerDashboard({ onBack }) {
  return (
    <div className="owner-dashboard-container">
      <button className="owner-back-btn" onClick={onBack}>← Back to Home</button>
      <h1 className="owner-dashboard-title">Owner Dashboard</h1>
      <AdminPanel />
    </div>
  );
}
